module.exports = __webpack_public_path__ + "static/media/off.6d0be388.svg";